__turbopack_context__.v({
  "award": "CardSimple-module-scss-module__STEipa__award",
  "card": "CardSimple-module-scss-module__STEipa__card",
  "cardContent": "CardSimple-module-scss-module__STEipa__cardContent",
  "cardInner": "CardSimple-module-scss-module__STEipa__cardInner",
  "cardLinkWrap": "CardSimple-module-scss-module__STEipa__cardLinkWrap",
  "cta": "CardSimple-module-scss-module__STEipa__cta",
  "eyebrow": "CardSimple-module-scss-module__STEipa__eyebrow",
  "fade-in": "CardSimple-module-scss-module__STEipa__fade-in",
  "featured": "CardSimple-module-scss-module__STEipa__featured",
  "image": "CardSimple-module-scss-module__STEipa__image",
  "imageContainer": "CardSimple-module-scss-module__STEipa__imageContainer",
  "isVisible": "CardSimple-module-scss-module__STEipa__isVisible",
  "textGroup": "CardSimple-module-scss-module__STEipa__textGroup",
  "theme--makers-reserve": "CardSimple-module-scss-module__STEipa__theme--makers-reserve",
});
